import apiClient from '../api/apiClient';

function unwrap(res) {
  const body = res?.data;
  if (body && typeof body === 'object' && 'data' in body) return body.data;
  return body;
}

const raReferralService = {
  /**
   * GET /api/v1/admin/ra-referrals/investors
   * Query params: page, limit, date_from, date_to (YYYY-MM-DD), rm_uuid (optional)
   * Response: { items, summary, pagination }
   */
  getInvestorReferrals: async (params = {}) => {
    const { signal, ...rest } = params;
    const defaultParams = {
      page: 1,
      limit: 20,
      ...rest,
    };
    const response = await apiClient.get('/api/v1/admin/ra-referrals/investors', {
      params: defaultParams,
      signal,
    });
    return unwrap(response);
  },
};

export default raReferralService;
